import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TopLevelDomain} from '@iana-rzms/bff-sdk';
// TODO(RZ-2562): Replace legacy VO types (ContactVO) with SDK equivalents (ContactInformation)
import {ContactVO} from '../../../generate/ContactVO';
import {ChangeVO} from '../../../generate/ChangeVO';


@Component({
    selector: 'contact-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.scss'],
    standalone: false
})
export class ContactInfoComponent implements OnInit {

  @ViewChild('contactInfoView') contactInfoView: ElementRef<HTMLElement>;
  @ViewChild('contactInfoEdit') contactInfoEdit: ElementRef<HTMLElement>;

  @Input()
  contactVO: ContactVO;
  @Input()
  type: string;
  @Input()
  domain: TopLevelDomain;
  @Input()
  lastchange: string;
  @Input()
  change: ChangeVO;
  @Input()
  pendingRequestChangeID: string;
  @Input()
  hasNonTechnicalPermission: boolean;
  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomain>();

  @Input()
  viewMode: boolean;
  editmode: boolean;

  @Output()
  contactInfoEditModeEnabled = new EventEmitter<boolean>();
  title: string;


  constructor() {
  }

  ngOnInit() {
    switch (this.type) {
      case 'AC':
        this.title = 'Administrative Contact';
        break;
      case 'TC':
        this.title = 'Technical Contact';
        break;
    }
  }

  edit(val) {
    this.editmode = val;
    this.contactInfoEditModeEnabled.emit(val);
    if (val) {
      this.contactInfoEdit.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    } else {
      setTimeout(() => {
        this.contactInfoView.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }, 1);
    }
  }

  cancel(val) {
    this.edit(false);
  }

  contactOutPut(contactVO: ContactVO) {
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

}
